/* Stressless Mayfair — configurator v3.2 (logica). Data + stijl: cfg-mayfair-data.js */
(function () {
  var D = (window.CFGMAYFAIR || {}).D || {};
  var CDN = D.CDN, CROP = D.CROP;
  if (!D.COVERS) return;

  var COLS = D.COVERS.map(function (s) {
    var p = s.split('|');
    return { code: p[0], name: p[1], type: p[2], groep: p[3],
      colors: p[4].split(',').map(function (c) { var q = c.split(':'); return { c: q[0], n: q[1] }; }) };
  });
  var COLBY = {}; COLS.forEach(function (c) { COLBY[c.code] = c; });
  var GRPLAB = {}; D.GROUPS.forEach(function (g) { GRPLAB[g[0]] = g[1]; });
  var BASE = {}; D.BASES.forEach(function (b) { BASE[b.k] = b; });

  var S = { base: 'cla', maat: 'M', vtb: 'ja', coll: '094', kleur: '45', hout: '04', alu: '45', frame: 'front', mat: 'leder', batt: false };
  var touched = false;

  function readHash() {
    var m = (location.hash || '').match(/cfg=([a-z0-9\-]+)/i); if (!m) return;
    var p = m[1].split('-');
    if (BASE[p[0]]) S.base = p[0];
    if (p[1]) S.maat = p[1].toUpperCase();
    if (p[2]) S.vtb = p[2];
    if (p[3] && COLBY[p[3].slice(0, 3)]) { S.coll = p[3].slice(0, 3); S.kleur = p[3].slice(3); }
    if (p[4]) S.hout = p[4];
    if (p[5]) S.alu = p[5];
    if (p[6]) S.batt = p[6] === 'b1';
    S.mat = COLBY[S.coll].type;
    normalise();
  }
  function writeHash() {
    if (!touched) return;
    var v = [S.base, S.maat, S.vtb, S.coll + S.kleur, S.hout, S.alu, S.batt ? 'b1' : 'b0'].join('-');
    try { history.replaceState(null, '', location.pathname + location.search + '#cfg=' + v); } catch (e) { }
  }
  function normalise() {
    var b = BASE[S.base];
    var sizes = Object.keys(b.art);
    if (sizes.indexOf(S.maat) < 0) S.maat = sizes.indexOf('M') >= 0 ? 'M' : sizes[0];
    if (!b.vtb) S.vtb = 'nee';
    var col = COLBY[S.coll];
    if (!col.colors.some(function (c) { return c.c === S.kleur; })) S.kleur = col.colors[0].c;
    S.mat = col.type;
  }
  function battOn() { return !!(S.batt && D.BATT && BASE[S.base].vtbIncl); }

  function tail(b) {
    if (b.tail === 'W') return S.hout;
    if (b.tail === 'AW') return S.alu + S.hout;
    return S.hout + '0';
  }
  function pid(baseKey, maat, coll, kleur) {
    var b = BASE[baseKey || S.base];
    var art = b.art[maat || S.maat] || b.art.M;
    return art + (coll || S.coll) + (kleur || S.kleur) + tail(b);
  }
  function shot(size, frame, o) {
    o = o || {};
    return CDN + pid(o.base, o.maat, o.coll, o.kleur) + '_' + size + '_' + (frame || 'front') + '.jpg';
  }
  var STOOL = { front: 'r', '01': 'l', '02': 'n', '03': 'r' };
  function frames() { return ['front', '01', '02', '03']; }
  function cropFor(frame) {
    if (S.vtb === 'ja' || !BASE[S.base].vtb) return null;
    var pos = STOOL[frame];
    if (pos === 'n') return null;
    return pos === 'r' ? 'left' : 'right';
  }
  function setShot(el, url, frame) {
    var c = cropFor(frame), inner = el.querySelector('.c3-in'), img = el.querySelector('img');
    if (c) {
      inner.style.width = (CROP * 100) + '%';
      img.style.width = (100 / CROP) + '%';
      img.style.marginLeft = c === 'left' ? '0' : ('-' + (100 / CROP - 100) + '%');
    } else {
      inner.style.width = '100%'; img.style.width = '100%'; img.style.marginLeft = '0';
    }
    if (img.getAttribute('src') !== url) {
      var pre = new Image();
      el.classList.add('busy');
      pre.onload = function () { img.src = url; el.classList.remove('busy'); };
      pre.onerror = function () { img.src = url; el.classList.remove('busy'); };
      pre.src = url;
    }
  }

  function grp() { return COLBY[S.coll].groep; }
  function prijs() {
    var t = D.P[S.base]; if (!t) return null;
    var row = t[BASE[S.base].vtb ? S.vtb : 'nee']; if (!row) return null;
    return row[grp()] || null;
  }
  function eur(n) { return '€ ' + Number(n).toLocaleString('nl-BE'); }
  function vanafGroep(g) {
    var t = D.P[S.base]; if (!t) return null;
    var row = t[BASE[S.base].vtb ? S.vtb : 'nee']; if (!row || !row[g]) return null;
    return row[g][0];
  }
  function vtbMeerprijs() {
    var t = D.P[S.base]; if (!t || !t.ja) return null;
    var g = grp(); if (!t.ja[g] || !t.nee[g]) return null;
    return t.ja[g][0] - t.nee[g][0];
  }

  var el = {};

  function media() {
    setShot(el.stage, shot('515x515', S.frame), S.frame);
    var t = '';
    frames().forEach(function (f) {
      t += '<button class=\"c3-th' + (f === S.frame ? ' on' : '') + '\" data-frame=\"' + f + '\" aria-label=\"Aanzicht\">' +
        '<span class=\"c3-shot\"><span class=\"c3-in\"><img loading=\"lazy\" alt=\"\"></span></span></button>';
    });
    el.thumbs.innerHTML = t;
    el.thumbs.querySelectorAll('[data-frame]').forEach(function (b) {
      var f = b.getAttribute('data-frame');
      setShot(b.querySelector('.c3-shot'), shot('300x300', f), f);
      b.onclick = function () { S.frame = f; media(); };
    });
  }

  function panel() {
    var b = BASE[S.base], col = COLBY[S.coll], out = '';
    var kleurNaam = (col.colors.filter(function (c) { return c.c === S.kleur; })[0] || {}).n || '';

    out += '<div class=\"c3-step\"><div class=\"c3-lab\"><span class=\"c3-no\">1</span> Onderstel<em>' + b.label + '</em></div><div class=\"c3-opts c3-bases\">';
    D.BASES.forEach(function (o) {
      out += '<button class=\"c3-card' + (o.k === S.base ? ' on' : '') + '\" data-base=\"' + o.k + '\">' +
        '<span class=\"c3-shot\"><span class=\"c3-in\"><img loading=\"lazy\" alt=\"Mayfair ' + o.label + '\" src=\"' +
        CDN + (o.art[S.maat] || o.art.M) + S.coll + S.kleur + (o.tail === 'W' ? S.hout : o.tail === 'AW' ? S.alu + S.hout : S.hout + '0') + '_300x300_front.jpg\"></span></span>' +
        '<b>' + o.label + '</b></button>';
    });
    out += '</div><p class=\"c3-note\">' + b.note + '</p></div>';

    var dims = (D.DIM[S.base] || {})[S.maat];
    out += '<div class=\"c3-step\"><div class=\"c3-lab\"><span class=\"c3-no\">2</span> Maat<em>' + S.maat + '</em></div><div class=\"c3-opts\">';
    ['S', 'M', 'L'].forEach(function (m) {
      var ok = !!b.art[m];
      out += '<button class=\"c3-chip' + (m === S.maat ? ' on' : '') + (ok ? '' : ' dis') + '\"' + (ok ? ' data-maat=\"' + m + '\"' : ' disabled') + '>' +
        '<img src=\"' + CDN + 'C_SIZE_' + m + '.svg\" alt=\"\"><span>' + { S: 'Small', M: 'Medium', L: 'Large' }[m] + '</span></button>';
    });
    out += '</div>';
    if (dims) out += '<p class=\"c3-note\">Breedte ' + dims[0] + ' cm · diepte ' + dims[1] + ' cm · hoogte ' + dims[2] +
      ' cm · zithoogte ' + dims[3] + ' cm · zitdiepte ' + dims[4] + ' cm' + (S.vtb === 'ja' ? ' · ' + D.VTBDIM : '') + '</p>';
    out += '</div>';

    if (b.vtb) {
      var mp = vtbMeerprijs();
      out += '<div class=\"c3-step\"><div class=\"c3-lab\"><span class=\"c3-no\">3</span> Voetenbank<em>' +
        (S.vtb === 'ja' ? 'Met voetenbank' : 'Zonder') + '</em></div><div class=\"c3-opts\">' +
        '<button class=\"c3-chip' + (S.vtb === 'ja' ? ' on' : '') + '\" data-vtb=\"ja\"><span>Met voetenbank' +
        (mp ? ' <i>+ ' + eur(mp) + '</i>' : '') + '</span></button>' +
        '<button class=\"c3-chip' + (S.vtb === 'nee' ? ' on' : '') + '\" data-vtb=\"nee\"><span>Zonder voetenbank</span></button>' +
        '</div></div>';
    } else if (b.vtbIncl) {
      out += '<div class=\"c3-step\"><div class=\"c3-lab\"><span class=\"c3-no\">3</span> Voetsteun<em>Geïntegreerd</em></div>' +
        '<p class=\"c3-note\">Bij Power™ zit de voetsteun in de zetel — elektrisch uitschuifbaar, geen losse voetenbank nodig.</p>';
      if (D.BATT) {
        out += '<div class=\"c3-opts\" style=\"margin-top:12px\">' +
          '<button class=\"c3-chip' + (!S.batt ? ' on' : '') + '\" data-batt=\"0\"><span>Met snoer naar het stopcontact</span></button>' +
          '<button class=\"c3-chip' + (S.batt ? ' on' : '') + '\" data-batt=\"1\"><span>Met batterij <i>+ ' + eur(D.BATT.prijs) + '</i></span></button>' +
          '</div><p class=\"c3-note\">Met de oplaadbare batterij zet je de zetel vrij in de kamer, zonder kabel naar een stopcontact.</p>';
      }
      out += '</div>';
    }

    out += '<div class=\"c3-step\"><div class=\"c3-lab\"><span class=\"c3-no\">4</span> Bekleding &amp; kleur<em>' + col.name + ' ' + kleurNaam + '</em></div>';
    out += '<div class=\"c3-tabs\">' +
      '<button class=\"c3-tab' + (S.mat === 'leder' ? ' on' : '') + '\" data-mat=\"leder\"><img src=\"' + CDN + 'leather.svg\" alt=\"\">Leder</button>' +
      '<button class=\"c3-tab' + (S.mat === 'stof' ? ' on' : '') + '\" data-mat=\"stof\"><img src=\"' + CDN + 'fabric.svg\" alt=\"\">Stof</button></div>';
    out += '<div class=\"c3-colls\">';
    COLS.filter(function (c) { return c.type === S.mat; }).forEach(function (c) {
      var v = vanafGroep(c.groep);
      out += '<button class=\"c3-pill' + (c.code === S.coll ? ' on' : '') + '\" data-coll=\"' + c.code + '\">' +
        '<b>' + c.name + '</b><span>' + (v ? 'vanaf ' + eur(v) : 'op aanvraag') + '</span></button>';
    });
    out += '</div><div class=\"c3-sw\">';
    col.colors.forEach(function (c) {
      out += '<button class=\"c3-swb' + (c.c === S.kleur ? ' on' : '') + '\" data-kleur=\"' + c.c + '\" title=\"' + col.name + ' ' + c.n + '\">' +
        '<img loading=\"lazy\" src=\"' + CDN + col.code + '_' + c.c + '_50.jpg\" alt=\"' + col.name + ' ' + c.n + '\"></button>';
    });
    out += '</div>';
    out += '<div class=\"c3-sel\" id=\"c3sel\"><img src=\"' + CDN + col.code + '_' + S.kleur + '_200.jpg\" alt=\"\">' +
      '<div><b>' + col.name + ' ' + kleurNaam + '</b><span>' + GRPLAB[col.groep] + ' · klik voor een grote weergave</span></div></div>';
    out += '</div>';

    var stap = 5;
    if (b.wood) {
      var hn = (D.WOOD.filter(function (w) { return w[0] === S.hout; })[0] || [])[1] || '';
      out += '<div class=\"c3-step\"><div class=\"c3-lab\"><span class=\"c3-no\">' + (stap++) + '</span> Houtkleur<em>' + hn + '</em></div><div class=\"c3-sw c3-wood\">';
      D.WOOD.forEach(function (w) {
        out += '<button class=\"c3-swb' + (w[0] === S.hout ? ' on' : '') + '\" data-hout=\"' + w[0] + '\" title=\"' + w[1] + '\">' +
          '<img loading=\"lazy\" src=\"' + CDN + 'C_WOODCOLOR_FURN_' + w[0] + '_50.jpg\" alt=\"' + w[1] + '\"></button>';
      });
      out += '</div><p class=\"c3-note\">Beuken, gebeitst in acht tinten — ook op de armleggers zichtbaar.</p></div>';
    }
    if (b.alu) {
      var an = (D.ALU.filter(function (a) { return a[0] === S.alu; })[0] || [])[1] || '';
      out += '<div class=\"c3-step\"><div class=\"c3-lab\"><span class=\"c3-no\">' + (stap++) + '</span> Kleur van de poot<em>' + an + '</em></div><div class=\"c3-opts\">';
      D.ALU.forEach(function (a) {
        out += '<button class=\"c3-chip' + (a[0] === S.alu ? ' on' : '') + '\" data-alu=\"' + a[0] + '\">' +
          '<img src=\"' + CDN + 'C_ALU_COLOR_' + a[0] + '_50.jpg\" alt=\"\"><span>' + a[1] + '</span></button>';
      });
      out += '</div></div>';
    }

    el.panel.innerHTML = out;
    bindPanel();
    priceBlocks();
  }

  function samenvatting() {
    var b = BASE[S.base], col = COLBY[S.coll];
    var kn = (col.colors.filter(function (c) { return c.c === S.kleur; })[0] || {}).n || '';
    var l = ['Mayfair ' + b.label, 'maat ' + S.maat];
    if (b.vtb) l.push(S.vtb === 'ja' ? 'met voetenbank' : 'zonder voetenbank');
    if (b.vtbIncl) l.push('voetsteun geïntegreerd');
    l.push(col.name + ' ' + kn);
    if (b.wood) l.push('hout ' + ((D.WOOD.filter(function (w) { return w[0] === S.hout; })[0] || [])[1] || ''));
    if (b.alu) l.push('poot ' + ((D.ALU.filter(function (a) { return a[0] === S.alu; })[0] || [])[1] || ''));
    if (battOn()) l.push('met batterij');
    return l.join(' · ');
  }

  function priceHTML(compact) {
    var pr = prijs();
    if (!pr) {
      return '<div class=\"c3-price\"><span class=\"c3-now\">Prijs op aanvraag</span>' +
        (compact ? '' : '<p class=\"c3-fine\">Deze samenstelling stellen we graag persoonlijk voor je samen.</p>') + '</div>';
    }
    return '<div class=\"c3-price\"><span class=\"c3-now\">' + eur(pr[0]) + '</span>' +
      '<span class=\"c3-was\">' + eur(pr[1]) + '</span><span class=\"c3-badge\">−10%</span>' +
      (compact ? '' : '<p class=\"c3-fine\">Actieprijs Stressless Store · je bespaart ' + eur(pr[1] - pr[0]) +
        ' · incl. btw · gratis levering in België en Nederland · levertijd ± 8 weken</p>') +
      (battOn() ? '<p class=\"c3-fine\" style=\"width:100%\">+ ' + eur(D.BATT.prijs) + ' batterij — samen <b>' + eur(pr[0] + D.BATT.prijs) + '</b></p>' : '') + '</div>';
  }

  function priceBlocks() {
    var pr = prijs();
    var btn = pr ? 'In winkelmand' : 'Vraag je prijs';
    el.buy.innerHTML = priceHTML(false) +
      '<div class=\"c3-sum\">' + samenvatting() + '</div>' +
      '<div class=\"c3-actions\"><button class=\"sp-btn sp-btn-dark\" id=\"c3add\">' + btn + '</button>' +
      '<a class=\"sp-btn sp-btn-outline\" href=\"#showroom\">Liever eerst proefzitten</a></div>' +
      '<div class=\"c3-msg\" id=\"c3msg\"></div>';
    el.bar.innerHTML = '<div class=\"c3-barin\"><div class=\"c3-barp\">' + priceHTML(true) +
      '<span class=\"c3-barsum\">' + samenvatting() + '</span></div>' +
      '<button class=\"sp-btn sp-btn-dark\" id=\"c3add2\">' + btn + '</button></div>';
    var f = function () { addToCart(); };
    var a = document.getElementById('c3add'); if (a) a.onclick = f;
    var a2 = document.getElementById('c3add2'); if (a2) a2.onclick = f;
  }

  function bindPanel() {
    var p = el.panel;
    p.querySelectorAll('[data-base]').forEach(function (b) { b.onclick = function () { S.base = b.getAttribute('data-base'); upd(true); }; });
    p.querySelectorAll('[data-maat]').forEach(function (b) { b.onclick = function () { S.maat = b.getAttribute('data-maat'); upd(true); }; });
    p.querySelectorAll('[data-vtb]').forEach(function (b) { b.onclick = function () { S.vtb = b.getAttribute('data-vtb'); upd(true); }; });
    p.querySelectorAll('[data-batt]').forEach(function (b) { b.onclick = function () { S.batt = b.getAttribute('data-batt') === '1'; upd(true); }; });
    p.querySelectorAll('[data-mat]').forEach(function (b) {
      b.onclick = function () {
        S.mat = b.getAttribute('data-mat');
        var first = COLS.filter(function (c) { return c.type === S.mat; })[0];
        S.coll = first.code; S.kleur = first.colors[0].c; upd(true);
      };
    });
    p.querySelectorAll('[data-coll]').forEach(function (b) {
      b.onclick = function () { S.coll = b.getAttribute('data-coll'); S.kleur = COLBY[S.coll].colors[0].c; upd(true); };
    });
    p.querySelectorAll('[data-kleur]').forEach(function (b) { b.onclick = function () { S.kleur = b.getAttribute('data-kleur'); upd(true); }; });
    p.querySelectorAll('[data-hout]').forEach(function (b) { b.onclick = function () { S.hout = b.getAttribute('data-hout'); upd(true); }; });
    p.querySelectorAll('[data-alu]').forEach(function (b) { b.onclick = function () { S.alu = b.getAttribute('data-alu'); upd(true); }; });
    var sel = document.getElementById('c3sel');
    if (sel) sel.onclick = function () {
      var col = COLBY[S.coll], kn = (col.colors.filter(function (c) { return c.c === S.kleur; })[0] || {}).n || '';
      openLB(CDN + col.code + '_' + S.kleur + '_200.jpg', col.name + ' ' + kn, true);
    };
  }

  function openLB(src, cap, small) {
    el.lb.querySelector('.c3-lbimg').innerHTML = '<img src=\"' + src + '\" alt=\"\"' + (small ? ' style=\"max-width:420px\"' : '') + '>';
    el.lb.querySelector('.c3-lbcap').textContent = cap;
    el.lb.classList.add('on');
  }

  function post(items) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('cart'); location.href = '/cart'; });
  }

  function addToCart() {
    var b = BASE[S.base], col = COLBY[S.coll], pr = prijs();
    var kn = (col.colors.filter(function (c) { return c.c === S.kleur; })[0] || {}).n || '';
    var msg = document.getElementById('c3msg');
    var o1 = b.label;
    var o2 = GRPLAB[col.groep];
    var o3 = (b.vtb && S.vtb === 'ja') ? 'Met voetenbank' : 'Zonder voetenbank';
    var link = location.origin + location.pathname + '#cfg=' + [S.base, S.maat, S.vtb, S.coll + S.kleur, S.hout, S.alu, S.batt ? 'b1' : 'b0'].join('-');

    var props = {
      'Maat': S.maat + ' (' + { S: 'Small', M: 'Medium', L: 'Large' }[S.maat] + ')',
      'Kleur': col.name + ' ' + kn
    };
    if (b.wood) props['Houtkleur'] = (D.WOOD.filter(function (w) { return w[0] === S.hout; })[0] || [])[1];
    if (b.alu) props['Kleur van de poot'] = (D.ALU.filter(function (a) { return a[0] === S.alu; })[0] || [])[1];
    if (b.vtbIncl) props['Voetsteun'] = 'Geïntegreerd (Power™)';
    if (battOn()) props['Batterij'] = 'Ja — draadloos gebruik (apart op de bestelling)';
    props['Let op'] = D.NOTE;
    props['_foto'] = shot('515x515', 'front');
    props['_crop'] = cropFor('front') || '';
    props['_link'] = link;

    if (location.hostname.indexOf('stresslessstore') < 0) {
      if (msg) { msg.className = 'c3-msg on'; msg.innerHTML = '<b>Preview</b> — dit komt in de winkelmand:<br>' + samenvatting() + '<br>' + (pr ? eur(pr[0]) : '') + ' · variant <code>' + [o1, o2, o3].join(' / ') + '</code>'; }
      return;
    }
    var btns = [document.getElementById('c3add'), document.getElementById('c3add2')].filter(Boolean);
    btns.forEach(function (x) { x.disabled = true; x.textContent = 'Bezig…'; });
    fetch('/products/' + D.HANDLE + '.js').then(function (r) { return r.json(); }).then(function (pd) {
      var v = pd.variants.filter(function (x) { return x.option1 === o1 && x.option2 === o2 && x.option3 === o3; })[0];
      if (!v) throw new Error('variant');
      var items = [{ id: v.id, quantity: 1, properties: props }];
      if (!battOn()) return post(items);
      return fetch('/products/' + D.BATT.handle + '.js').then(function (r) { return r.json(); }).then(function (bp) {
        items.push({ id: bp.variants[0].id, quantity: 1, properties: { 'Hoort bij': 'Stressless® Mayfair Power™ (' + o2 + ')' } });
        return post(items);
      });
    }).catch(function () {
      btns.forEach(function (x) { x.disabled = false; x.textContent = 'In winkelmand'; });
      if (msg) { msg.className = 'c3-msg on'; msg.innerHTML = 'Deze samenstelling kunnen we niet online afronden. <a href=\"#mayfair-contact\">Stuur ons je keuze door</a> of bel de winkel — we regelen het meteen voor je.'; }
    });
  }

  function upd(fromUser) {
    if (fromUser) touched = true;
    normalise(); panel(); media(); writeHash();
  }

  function mount() {
    if (location.pathname.indexOf('stressless-mayfair') < 0) return null;
    var sec = document.getElementById('configurator');
    if (!sec) return null;
    if (!document.getElementById('c3css')) {
      var st = document.createElement('style');
      st.id = 'c3css';
      st.textContent = ((window.CFGMAYFAIR || {}).CSS || '');
      document.head.appendChild(st);
    }
    ['cfgModal', 'cfgLb'].forEach(function (id) { var e = document.getElementById(id); if (e) e.style.display = 'none'; });
    sec.className = 'sp-beech';
    sec.innerHTML =
      '<div class=\"wrap c3\">' +
      '<p class=\"eyebrow center\">Stel jouw zetel samen</p>' +
      '<h2 class=\"center\" style=\"max-width:22ch\">Zie meteen hoe jouw Mayfair eruitziet</h2>' +
      '<p class=\"measure center\" style=\"margin-top:14px\">Onderstel, maat, bekleding, houtkleur — bij elke keuze verandert de foto mee. Wat je hier ziet, is exact de zetel die we voor je bestellen.</p>' +
      '<div id=\"cfg3\"></div>' +
      '<div class=\"c3-trust\"><span>Gratis levering in België én Nederland</span>' +
      '<span>Levertijd ± 8 weken · op maat gemaakt in Noorwegen</span>' +
      '<span>Beste prijsgarantie</span></div>' +
      '</div>';
    return document.getElementById('cfg3');
  }

  function init() {
    var root = mount();
    if (!root) return;
    root.innerHTML =
      '<div class=\"c3-grid\">' +
      '<div class=\"c3-media\"><div class=\"c3-stage c3-shot\" id=\"c3stage\"><span class=\"c3-in\"><img alt=\"Stressless Mayfair\"></span>' +
      '<button class=\"c3-zoom\" id=\"c3zoom\" aria-label=\"Vergroot\">⤢</button></div>' +
      '<div class=\"c3-thumbs\" id=\"c3thumbs\"></div></div>' +
      '<div class=\"c3-right\"><div class=\"c3-panel\" id=\"c3panel\"></div><div class=\"c3-buy\" id=\"c3buy\"></div></div>' +
      '</div>' +
      '<div class=\"c3-bar\" id=\"c3bar\"></div>' +
      '<div class=\"c3-lb\" id=\"c3lb\"><div class=\"c3-lbimg\"></div><p class=\"c3-lbcap\"></p></div>';
    el.stage = document.getElementById('c3stage');
    el.thumbs = document.getElementById('c3thumbs');
    el.panel = document.getElementById('c3panel');
    el.buy = document.getElementById('c3buy');
    el.bar = document.getElementById('c3bar');
    el.lb = document.getElementById('c3lb');
    el.lb.onclick = function () { el.lb.classList.remove('on'); };
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') el.lb.classList.remove('on'); });
    document.getElementById('c3zoom').onclick = function (e) {
      e.stopPropagation();
      openLB(shot('2400x2400', S.frame), samenvatting());
    };
    readHash();
    upd();
    if (typeof window.CFG_TWEAK === 'function') { try { window.CFG_TWEAK({ S: S, upd: upd, shot: shot, D: D }); } catch (e) { } }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
